/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import style from './dashboard.module.css';
import TransactionCampaign from '../Campaigns/TransactionCampaign';
import Header from '../../components/Header/header';


const Dashboard: React.FC = () => {
    return (
        <>
            <Header />
            <div className={style.scroll}>
                <TransactionCampaign />
            </div>
        </>
    );
};

export default Dashboard;
